import Styled from 'styled-components';

const HeaderContainer = Styled.div``;

const DataWrapper = Styled.div`
  display: column;
  padding-bottom: 15px;
`;

const RatingsContainer = Styled.div`
`;

const Text = Styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  color: #666666;
  margin-left: 15px;
`;

export default HeaderContainer;
export { HeaderContainer, DataWrapper, RatingsContainer, Text };
